import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VBtn,_vm._g({staticClass:"elevation-8",attrs:{"color":_vm.color,"loading":_vm.loading,"disabled":_vm.disabled,"fab":"","fixed":"","bottom":"","right":""}},_vm.$listeners),[_c(VIcon,[_vm._v("add")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }